import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthStateService } from '../../core/services/auth-state.service';

export const AdminGuard = (): CanActivateFn => {
  return (route: ActivatedRouteSnapshot) => {
    const authStateService = inject(AuthStateService);
    const router = inject(Router);

    if (!authStateService.isLoggedIn() || !authStateService.isAdmin()) {
      router.navigate(['/login']);

      return false;
    }

    return true;
  };
};
